import React from 'react';
import { DataSetEditHTTPIntegrationHook } from 'apps/sigma2-ui/src/data-wizard/lib/useDataSetEditHTTPIntegration';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DataSetHTTPConfigurationURLListComponent = ({
  httpIntegrationHook,
}: {
  httpIntegrationHook: DataSetEditHTTPIntegrationHook;
}) => {
  const language = useLanguage();

  return (
    <>
      <S2Typography
        variant={'headline-3'}
        translatedContent={language.urlList()}
      />
      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            httpIntegrationHook.setHttpIntegration({
              ...httpIntegrationHook.httpIntegration,
              urlList: [
                ...httpIntegrationHook.httpIntegration.urlList,
                {
                  url: '',
                  filename: '',
                },
              ],
            });
          },
        }}
        text={'Add URL'}
      />
      <Table
        items={httpIntegrationHook.httpIntegration.urlList}
        columnDefinitions={[
          {
            id: 'url',
            header: () => <div>URL</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'url'}
                value={item.url}
                aria-label={'url'}
                onChange={(event) => {
                  const newUrlList = [
                    ...httpIntegrationHook.httpIntegration.urlList,
                  ];
                  newUrlList[rowIndex] = {
                    ...newUrlList[rowIndex],
                    url: event.target.value,
                  };
                  httpIntegrationHook.setHttpIntegration({
                    ...httpIntegrationHook.httpIntegration,
                    urlList: newUrlList,
                  });
                }}
              />
            ),
          },
          {
            id: 'filename',
            header: () => <div>Filename</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'filename'}
                value={item.filename}
                aria-label={'filename'}
                onChange={(event) => {
                  const newUrlList = [
                    ...httpIntegrationHook.httpIntegration.urlList,
                  ];
                  newUrlList[rowIndex] = {
                    ...newUrlList[rowIndex],
                    filename: event.target.value,
                  };
                  httpIntegrationHook.setHttpIntegration({
                    ...httpIntegrationHook.httpIntegration,
                    urlList: newUrlList,
                  });
                }}
              />
            ),
          },
          {
            id: 'actions',
            header: () => <div>Actions</div>,
            cell: ({ rowIndex }) => (
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    const newUrlList = [
                      ...httpIntegrationHook.httpIntegration.urlList,
                    ];
                    newUrlList.splice(rowIndex, 1);
                    httpIntegrationHook.setHttpIntegration({
                      ...httpIntegrationHook.httpIntegration,
                      urlList: newUrlList,
                    });
                  },
                }}
                text={'Remove'}
              />
            ),
          },
        ]}
      />
    </>
  );
};
